import React, { ReactElement } from 'react';
import { TextBlock } from '@kursk/components/ui/ContentBlock/TextBlock/TextContent';
import { WidgetBlock } from '@kursk/components/ui/ContentBlock/WidgetBlock/WidgetBlock';
import { ImagePortrait } from '@kursk/components/ui/ImagePortrait/ImagePortrait';
import { ImageDescription } from '@kursk/components/ui/ImageDescription/ImageDescription';
import { GalleryBlock } from '@kursk/components/ui/GalleryBlock/GalleryBlock';
import { WidgetVideo } from '@kursk/components/ui/ContentBlock/WidgetBlock/WidgetVideo/WigetVideo';

import styles from './ContentBlock.module.scss';
import { IEventContent } from "@common/redux/types/event";
import { ArtefactBlock } from "@kursk/components/ui/ContentBlock/ArtefactBlock/ArtefactBlock";
import { useRouter } from "next/router";
import classNames from "classnames";
import { SourceBlock } from "@kursk/components/ui/ContentBlock/SourceBlock/SourceBlock";
import { ISource } from "@common/redux/types/common";

interface IProps {
  content: IEventContent[],
  needShowMore?: boolean,
  classes?: string,
  source: ISource,
}

export const ContentBlock = ({ content, source, needShowMore = false, classes }: IProps): ReactElement => {
  const router = useRouter();

  const renderContent = (item, index: number) => {
    const findFirstVideo = content.findIndex((widget) => widget.type === 'video');

    if (item.type === 'text') {
      return (
        <div key={`${item.type}${index}`} className={styles.blockWrapper}>
          <TextBlock key={`${item.type}${index}`} text={item.text} needShowMore={needShowMore}/>
        </div>
      );
    }
    if (item.type === 'widget') {
      return (
        <div key={`${item.type}${index}`} className={classNames(styles.blockWrapper, styles.widgetWrapper)}>
          <WidgetBlock key={`${item.type}${index}`} widget={item.widget} index={index}/>
        </div>
      );
    }
    if (item.type === 'artefact') {
      return (
        <div key={`${item.type}${index}`} className={styles.blockWrapper}>
          <ArtefactBlock artefact={item.artefact}/>
        </div>
      );
    }
    if (item.type === 'image') {
      return (
        <div
          key={`${item.type}${index}`}
          className={classNames(styles.imgBlockWrapper, styles.blockWrapper)}
        >
          <div className={styles.imgBlock}>
            <ImagePortrait image={item.image} useFullscreen={true} />
          </div>
          <ImageDescription image={item.image} />
        </div>
      );
    }
    if (item.type === 'gallery') {
      return (
        <div key={`${item.type}${index}`} className={classNames(styles.galleryWrapper, styles.blockWrapper)}>
          <GalleryBlock images={item.gallery}/>
        </div>
      );
    }
    if (item.type === 'video') {
      return (
        <div className={classNames(styles.blockWrapper, styles.videoWrapper)} key={`${item.type}${index}`}>
          <WidgetVideo
            widget={item.video}
            scrollToVideo={index === findFirstVideo && router.query.scroll === 'videoFrame'}
          />
        </div>
      )
    }
    return <></>
  }

  return (
    <div className={styles.content}>
      <div className={classNames(styles.wrapper)}>
        {typeof content === 'string' ?
          <TextBlock text={content} needShowMore={needShowMore} classes={classes}/> :
          content?.map(renderContent)
        }
      </div>
      {(source && source.name) && <div className={styles.sourceWrapper}><SourceBlock source={source}/></div>}
    </div>
  )
};
